/** Prisma-free so middleware and client components can import these. */

/** Stamped onto the NextAuth JWT when the account is gone or deactivated. */
export const ACCOUNT_DELETED_TOKEN_ERROR = "AccountDeleted";

/** Public page shown after an admin (or other) deletion kills a live session. */
export const ACCOUNT_DELETED_PATH = "/account-deleted";

/**
 * Same idea as Instagram/Discord/Slack when an account is disabled: say so
 * plainly, then point people to support if they think it was a mistake.
 */
export const ACCOUNT_DELETED_TITLE = "This account has been deleted";
export const ACCOUNT_DELETED_NOTICE =
  "This account has been deleted. If you believe this is an error, please contact support.";
